import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { RevisionInfo } from "@components/revision-info/models/revision-info.model";

@Component({
    selector: 'app-recurrence-modal',
    templateUrl: './recurrence-modal.component.html',
    styleUrls: ['./recurrence-modal.component.scss']
})
export class RecurrenceModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: false}) modal: ModalComponent;

    @Input() title = '';

    revisionInfo: RevisionInfo;
    constructor() {
        this.revisionInfo = new RevisionInfo();
    }

    ngOnInit() {
    }

    open(revisionInfo: RevisionInfo) {
        if (revisionInfo) {
            this.revisionInfo = revisionInfo;
        }
        this.modal.open();
    }

    onCancel() {
        this.revisionInfo = null;
        this.modal.close();
    }

}
